import { Injectable } from '@angular/core';
import { ScriptLoaderService, ScriptModel } from '@app/core/services';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PazeService {
  pazeScriptLoaded: boolean;
  private digitalWalletAdaptor: any;
  pazeInitialized: boolean;

  constructor(private scriptLoader: ScriptLoaderService) {
    this.pazeScriptLoaded = false;
   }
  public loadScript(scriptId: string): Observable<ScriptModel> {
    const scriptSrc =  `${environment.paze.SCRIPT_URL}?id=${environment.CHASE_PAYMENT_CONFIG[0].data.merchantIdentifier}`;
    return this.scriptLoader.load({id: scriptId, src: scriptSrc, loaded: false});
  }
  public setPazeLoadStatus(status: boolean) {
    this.pazeScriptLoaded = status;
  }
  public initialize(): Promise<any> {
    this.digitalWalletAdaptor = window['DIGITAL_WALLET_SDK'];
    return this.digitalWalletAdaptor.initialize(
      {
        client: environment.paze.client     
      } as ClientAttributes
    );
  }
  public checkout(request: CheckoutRequest) : Promise<CheckoutResponse> {
    return this.digitalWalletAdaptor.checkout(request);
  }
  public complete(request: CheckoutCompleteRequest): Promise<CheckoutCompleteResponse> {
    return this.digitalWalletAdaptor.complete(request);
  }
}
export interface CheckoutResponse {
  result: string
  checkoutResponse: string
}
export interface Client {
  id: string
  name: string
  profileId: string
}
export interface ClientAttributes {
  client: Client
}
export interface CheckoutRequest {
  emailAddress?: string
  actionCode: string
  sessionId: string
  transactionValue: TransactionValue
  enhancedTransactionData?: EnhancedTransactionData
  intent?: 'REVIEW_AND_PAY' | 'EXPRESS_CHECKOUT' | 'ADD_CARD',
  shippingPreference?: 'ALL' | 'NONE';
}
export interface CheckoutCompleteRequest {
  // emailAddress?: string
  // actionCode: string
  sessionId: string
  transactionType: 'PURCHASE' | 'CARD_ON_FILE' | 'BOTH'
  transactionOptions: TransactionOptions
  enhancedTransactionData?: EnhancedTransactionData
  processingNetwork? : string
  transactionValue: TransactionValue
}
export interface EnhancedTransactionData {
  ecomData?: EcomData
  travelData?: TravelData
  cartContainsGiftCard?: boolean
  orderForPickup?: boolean
  orderQuantity?: string
  orderHighestCost?: string
  finalShippingAddress?: PazeAddress
}
export interface EcomData {
  cartContainsGiftCard?: boolean;
  orderForPickup?: boolean;
  orderQuantity?: string;
  orderHighestCost?: string;
  finalShippingAddress?: PazeAddress;
}
export interface TravelData {
  passengerName?: string;
  roundTrip?: boolean;
  departureDate?: string;
  returnDate?: string;
  departureLocation?: PazeAddress;
  returnLocation?: PazeAddress;
}

export interface TransactionValue {
  transactionCurrencyCode: string
  transactionAmount: string
}
export enum CheckoutResponseResult {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'  
}
export interface CheckoutCompleteResponse {
  completeResponse: string
}
export interface TransactionOptions {
  merchantCategoryCode?: string;
  billingPreference?: string;
  payloadTypeIndicator?: string;
}
export interface PazeAddress {
  name?: string
  line1?: string
  line2: string
  line3?: string
  city?: string
  state?: string
  zip: string
  countryCode: string
}



